{
    "breadcrumbs": {
        "eligibility": "Sobre usted",
        "eligibility_mobile": "Sobre usted",
        "consent": "Consentimiento",
        "consent_mobile": "Consentimiento",
        "memory": "Pruebe su edad cerebral",
        "memory_mobile": "Prueba",
        "contact": "Información de contacto",
        "contact_mobile": "Contacto",
        "estimatedTime_one": "{{count, number}} min",
        "estimatedTime_other": "{{count, number}} min",
        "done": "Terminado",
        "survey": "Realiza una encuesta rápida",
        "survey_mobile": "Encuesta",
        "finish": "Terminar",
        "finish_mobile": "Terminar"
    },
    "footer": {
        "promotion": "Novoic se está utilizando para evaluar a personas desde la comodidad de su casa en más de 50 instituciones. Storyteller no es un dispositivo médico y no tiene eficacia médica. No está destinado a diagnosticar o tratar ninguna enfermedad. Para cualquier preocupación de salud, por favor consulte a un profesional médico.",
        "about": {
            "text": "Acerca de",
            "link": "https:\/\/novoic.com\/"
        },
        "terms": {
            "text": "Términos",
            "link": "https:\/\/novoic.com\/storyteller\/tos"
        },
        "privacy": {
            "text": "Privacidad",
            "link": "https:\/\/novoic.com\/storyteller\/privacy"
        },
        "help": {
            "text": "Centro de Ayuda",
            "link": "https:\/\/novoic.com\/"
        }
    },
    "stepper": {
        "title_mobile": "Paso {{count, number}} de {{total, number}}: {{title}}"
    },
    "share": {
        "title": "¡Invita a alguien a quien aprecias a hacer Storyteller!",
        "divider": "o",
        "cta": "Enviar Invitación",
        "buttons": {
            "copy": "Copiar Enlace",
            "email": "Invitar por Correo Electrónico"
        },
        "email": {
            "subject": "",
            "body": "{{link}}"
        }
    }
}
